import {observer} from 'mobx-react';
import React from 'react';
import {LessonTypeSelect} from '../../../../lib/components';
import {X4UnitStore} from '../X4UnitStore';

@observer
export class EditLessonForm extends React.Component<{ store: X4UnitStore }> {
  render() {
    const {store} = this.props;

    if (store.editLesson === null)
      return null;

    const name = store.editLesson.name;
    const lessonType = store.editLesson.lessonType;
    return (
      <div className="row">
        <div className="col">
          <div className={lessonType.formGroupClassName}>
            <LessonTypeSelect value={lessonType.value}
                              onChange={lessonType.setValue}
                              onBlur={lessonType.markTouched}/>
            <div className="invalid-text">Enter lesson type</div>
          </div>
        </div>
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
